import React from 'react';
import styles from '../../Tabs.module.scss';
const Group = ({ children }) => {
    return (React.createElement("div", { className: styles.group },
        React.createElement("div", { className: styles.content }, children)));
};
export default Group;
